/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Component, ComponentFactoryResolver, ComponentRef, HostListener, Input, ViewChild, ViewContainerRef, TemplateRef, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NotesInfoContentComponent } from './notes-info-content/notes-info-content.component';
import { EventEmitter } from '@angular/core';
import { ClientProvider } from 'src/app/providers';
import { CrmAlertComponent } from 'src/app/components/fields';

@Component({
  selector: 'notes-info',
  templateUrl: 'notes-info.component.html',
  styleUrls: ['notes-info.component.scss']
})

export class NotesInfoComponent {
  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  @ViewChild('alert') alert: CrmAlertComponent;
  @Input() data: any;
  @Input() disabled = false;
  @Input() showHover = true;
  @Output() updateNotes = new EventEmitter();

  private tooltip: ComponentRef<any>;
  private visible: boolean;
  modalRef: BsModalRef;
  notesEdit: string;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    private modalService: BsModalService,
    public clientProvider: ClientProvider
  ) { }

  @HostListener('focusin')
  @HostListener('mouseenter')
  showInfo(): void {

    if (this.visible || !this.showHover || !this.data)
      return;

    this.visible = true;
    const factory = this.resolver.resolveComponentFactory(NotesInfoContentComponent);

    this.tooltip = this.target.createComponent(factory);
    this.tooltip.instance.hostElement = this.viewContainerRef.element.nativeElement;
    this.tooltip.instance.data = this.data;
  }

  @HostListener('focusout')
  @HostListener('mouseleave')
  hideInfo(): void {
    if (!this.visible)
      return;

    this.visible = false;
    if (this.tooltip)
      this.tooltip.destroy();
  }

  /**
   * Open modal to edit text.
   * @param template
  */
  openModal($event: MouseEvent, template: TemplateRef<any>): void {
    event.stopImmediatePropagation();
    this.notesEdit = this.data['NOTES'];
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });

  }

  /**
   * Update notes of the client profile.
  */
  updateValue(): void {
    this.data.NOTES = this.notesEdit;
    this.clientProvider.saveClient(this.data)
      .subscribe(data => {
        if (data.success) {
          this.updateNotes.emit(this.data);
          this.closeModal();
        } else {
          this.alert.show(data.error);
        }
      });
  }

  /**
   * Close notes modal .
  */
  closeModal(): void {
    this.modalRef.hide();
    this.notesEdit = '';
  }
}


